import get from 'lodash/get';
import set from 'lodash/set';

import { BLOCK_TYPE, DEFAULT_CHILDREN } from '../constants';

import getPrepareMarks from './getPrepareMarks';

const getPrepareChildren = (children) => {
  if (!children) return DEFAULT_CHILDREN;

  const stack = [...children];
  const prepareChildren = [];

  while (stack.length > 0) {
    const child = stack.shift();

    const {
      nodes,
      type,
      data,
      marks,
      text,
      parentPath,
    } = child;

    if (type === BLOCK_TYPE.IMAGE) continue;

    const prepareData = {};
    const prepareMarks = getPrepareMarks(marks);

    if (text) {
      prepareData.text = text;
    } else if (!nodes && !type) {
      prepareData.text = '';
    }

    if (type) {
      prepareData.type = type;

      if (!nodes) prepareData.children = DEFAULT_CHILDREN;
    }

    if (data) prepareData.data = data;

    if (nodes) {
      prepareData.children = [];

      if (type === BLOCK_TYPE.IMAGE_BLOCK && nodes.every((el) => el.type === BLOCK_TYPE.IMAGE)) {
        prepareData.children = DEFAULT_CHILDREN;
      } else {
        nodes.forEach((node) => {
          const allChildren = get(prepareChildren, parentPath);
          const newParentPath = parentPath ? [...parentPath, allChildren.length, 'children'] : [prepareChildren.length, 'children'];

          stack.push({
            ...node,
            parentPath: newParentPath,
          });
        });
      }
    }

    if (parentPath) {
      const allChildren = get(prepareChildren, parentPath);

      set(prepareChildren, parentPath, [...allChildren, { ...prepareData, ...prepareMarks }]);
    } else {
      prepareChildren.push({ ...prepareData, ...prepareMarks });
    }
  }

  return prepareChildren.length > 0 ? prepareChildren : DEFAULT_CHILDREN;
};

export default getPrepareChildren;
